// extracted by mini-css-extract-plugin
export default {"button":"Button_button__85C4R","clickable":"Button_clickable__hB+Dp","dark":"Button_dark__AeKh0","buttonSecondary":"Button_buttonSecondary__PfvMH"};